import BaseModelFactory from './base.factory'
import LedgerTransactionRuleService from './../services/LedgerTransactionRule.service'
import LedgerTransactionRule from './../models/ledger-transaction-rule.model'

class LedgerTransactionRuleFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: LedgerTransactionRuleService, Model: LedgerTransactionRule }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: LedgerTransactionRuleService, Model: LedgerTransactionRule })
  static create = payload =>
    this._create(payload, {
      Service: LedgerTransactionRuleService,
      Model: LedgerTransactionRule,
    })
}

export default LedgerTransactionRuleFactory
